import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({ template: '', standalone: false })
export class AuthRedirectComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    const namespace = this.route.snapshot.paramMap.get('namespace');
    const tenant = this.route.snapshot.paramMap.get('tenant');
    const additionalQueryParams = this.route.snapshot.queryParams;
    const queryParams = {
          ...(namespace && {namespace}),
          ...(tenant && {tenant}),
          ...additionalQueryParams,
    };
    this.router.navigate(['/'], { queryParams });
  }
}
